import { useState, useRef, useEffect } from 'react';
// import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router';
import { 
  // Link, 
  useLocation } from 'react-router-dom';
import Dialog from 'components/Dialog';
// import { ReactComponent as ArrowSVG } from 'assets/icon-arrow-right.svg';
// import { ReactComponent as InfoSVG } from 'assets/icon-info.svg';
import { ReactComponent as SortSVG } from 'assets/icon-sort.svg';
import NonPic from 'assets/nonPic.png';
import TextField from 'components/TextField';
import styles from './index.module.scss';
import { format } from 'date-fns';
import { useAuth } from 'context/Auth';
import { listUserVoucherLogs, UserVoucherLogsData } from 'api/logs';
import { updateUserVoucherLogs } from 'api/return';
import { useGlobalError } from 'context/Error/GlobalErrorContext';
// import { ListItem } from '@mui/material';

// type DiscountData = {
//   id: number;
//   svpt_info: string;
//   created_at: string;
//   use_type?: number; // 21.12.22 SCH
//   redeem_code?: string;
//   giftcard_code?: string;
//   redeem_url?: string;
//   pin_code?: string;
//   used?: boolean; // 21.12.29 SCH
//   picture_url?: string; // 22.05.29 SCH
//   picture_url_small?: string; // 20230418 wilson add
// };

type FormData = {
  auth_num?: string;
};
type FormName = 'auth_num'; 

const OfflineDiscount = () => {
  const [filter, setFilter] = useState<'all' | 'useable' | 'expired'>('useable');
  const [sort, setSort] = useState<'ascend' | 'descend'>('descend');
  const filterRef = useRef<string>('useable'); 
  const sortRef = useRef<string>('descend'); 
  const [redeemVisible, setRedeemVisible] = useState<boolean>(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { accessToken, me } = useAuth(); 
  const [userVoucherLogs, setUserVoucherLogs] = useState<UserVoucherLogsData[]>();
  const userVoucherLog_id = useRef<number>(0); 
  const useType = useRef<number>(); 
  const redeemUrl = useRef<string>(); 
  const buttonLabel = useRef<string>(); 
  const redeemCode = useRef<string>(); 
  const authNum = useRef<number>(); 
  const [formData, setFormData] = useState<FormData>({ auth_num: '',});
  let imgPreUrl = 'https://packageplusmainsys.s3-ap-northeast-1.amazonaws.com/';
  const { showError } = useGlobalError()

  const refreshPage = () => {
    window.location.reload(); 
  };
  useEffect(() => {
    fetchUserVoucherLogs(); 
    // eslint-disable-next-line
  }, [pathname]);

  const nowDate = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
  
  const fetchUserVoucherLogs = async () => {
    try {
      const { data } = await listUserVoucherLogs(accessToken!, 1, me?.id!,
        filterRef.current, sortRef.current);
        
      if (!data) {
        return 'Have not any Vouchers !!';
      } else {
        // FIXME: change back to data for display real data from server
        setUserVoucherLogs(data);
      }
    } catch (e: any) {
      console.log(e);
      showError(e, 'error')
    }
  };
  
  // 22.05.30 SCH, vip 2.0 已挪到(discountInfo.tsx)使用!!
  const changeUserVoucherLogs = async () => {
    try {
      const { data } = await updateUserVoucherLogs(accessToken!, 1, {
        id: userVoucherLog_id.current,
        userVoucherLog_id: userVoucherLog_id.current,
      });
      console.log(data);
    } catch (error) {
      console.log(error);
    }
    refreshPage(); 
  };

  const formatDate = (dateStr: string) => {
    if (dateStr.indexOf('T') > 0) {
      let newDate = format(new Date(dateStr), 'yyyy-MM-dd HH:mm:ss');
      return newDate; 
    }
    return dateStr;
  };
  
  const onFormChange = async (name: FormName, value: any) => {
    const tmp: FormData = { ...formData };
    tmp[name] = value;
    setFormData(tmp);
  };

  const isEnabled = () => {
    if (!formData.auth_num) {
      return false;
    }
    if (formData.auth_num !== authNum.current?.toString()) {
      return false;
    }
    return true;
  };

  const onConfirm = () => {
    if (formData.auth_num !== authNum.current?.toString()) {
      return false;
    }
    setRedeemVisible(false);
    switch (useType.current) {
      case 1:
        changeUserVoucherLogs();
        break;
      case 2:
        changeUserVoucherLogs();
        window.open(redeemUrl.current);
        break;
      case 3:
        changeUserVoucherLogs();
        break;
      case 4:
        changeUserVoucherLogs();
        window.open(redeemUrl.current);
        break;
    }
    // navigate('/payment');
  };
  const onCancel = () => {
    setRedeemVisible(false);
  };

  return (
    <>
      <div className={styles.toolbar}>
        <div className={styles.filters}>
          <button
            className={filter === 'all' ? styles.active : undefined}
            onClick={() => {
              setFilter('all');
              filterRef.current = 'all';
              fetchUserVoucherLogs();
            }}
          >
            全部
          </button>
          <button
            className={filter === 'useable' ? styles.active : undefined}
            onClick={() => {
              setFilter('useable');
              filterRef.current = 'useable';
              fetchUserVoucherLogs();
            }}
          >
            可使用
          </button>
          <button
            className={filter === 'expired' ? styles.active : undefined}
            onClick={() => {
              setFilter('expired');
              filterRef.current = 'expired';
              fetchUserVoucherLogs();
            }}
          >
            已逾期
          </button>
        </div>
        <div className={styles.sort}>
          <button
            onClick={() => {
              setSort(sort === 'ascend' ? 'descend' : 'ascend');
              sortRef.current = sort === 'ascend' ? 'descend' : 'ascend';
              fetchUserVoucherLogs();
            }}
          >
            {sort === 'descend' ? '最新' : '最舊'}
            <SortSVG />
          </button>
        </div>
      </div>

      <div className={styles.list}>
        {userVoucherLogs?.map((item) => (
          <div key={item.id} className={styles.listItem}>
            <div className={styles.shadow}></div>
            <img src={
              (
                item.picture_url_small === null || 
                item.picture_url_small === 'null' || 
                item.picture_url_small.trim() === ''
              )  
              ? NonPic : imgPreUrl+item.picture_url_small } alt="" className={styles.img} />
            <div className={styles.info}>
              <h5>{item.svpt_info}</h5>
              <span className={styles.date}>{formatDate(item.created_at)}</span>
            </div>
            <div className={styles.btnContainer}>
              <button
                disabled={item.expired_use_at < nowDate ? true :  false }
                onClick={() => {
                  navigate(`${item.id}`);
                }}
              >
                { item.expired_use_at < nowDate ? '已逾期' : '詳情'}
              </button>
            </div>
          </div>
        ))}
      </div>

      <Dialog
        visible={redeemVisible}
        onConfirm={onConfirm}
        onCancel={onCancel}
        message={
          <div className={styles.dialogHeader}>
            <h5>歸還獎勵兌換</h5>
            <div>
              <h5>{redeemCode.current}</h5>
            </div>
            <div className={styles.authNum}>
              <p>{authNum.current}</p>
            </div>
            <div className={styles.authNumBottom}>
              <TextField
                type="text"
                label="驗證碼"
                name="auth_num"
                InputLabelProps={{ style: { fontSize: 24 } }}
                InputProps={{ style: { fontSize: 24 } }}
                onChange={(event) =>
                  onFormChange('auth_num', event.target.value)
                }
              />
            </div>
            <p>請至櫃檯出示此畫面來兌換獎勵</p>
            <p>驗證通過後請點擊「{buttonLabel.current}」以完成兌換</p>
          </div>
        }
        cancelText="下次再說"
        okText={buttonLabel.current}
        cancelable
        showOk={isEnabled()}
      />
    </>
  );
};

export default OfflineDiscount;
